export const parseNewMatchesParams = (search = '') => {
  const params = new URLSearchParams(search);
  const newMatchesMode = params.get('newMatches') === 'true';
  const notificationId = params.get('notificationId') || null;
  return { newMatchesMode, notificationId };
};

export const appendNewMatchesToCriteria = (criteria, { newMatchesMode, notificationId }) => {
  if (!newMatchesMode) {
    return criteria;
  }
  const result = { ...criteria, 'new-matches': true };
  if (notificationId) {
    result['notification-id'] = notificationId;
  }
  return result;
};

export const buildAllMatchesSearch = (search = '') => {
  const params = new URLSearchParams(search);
  params.delete('newMatches');
  params.delete('notificationId');
  const query = params.toString();
  return query ? `?${query}` : '';
};

export const preserveQueryParamsOnLocationChange = (currentSearch, placeId) => {
  const params = new URLSearchParams(currentSearch || '');
  params.set('locationId', placeId);
  params.delete('page');
  const query = params.toString();
  return query ? `?${query}` : '';
};
